export const APP_ROOT_ID = 'header-root';
export const MB_EVENT_HAMBURGER_CLICKED = 'wh.header.event.hamburger.clicked';
export const HEADER_PROPS_UPDATE_REQUESTED = 'wh.header.piHeaderPropsUpdate.requested';
export const HEADER_TYPE_CHANGED = 'wh.header.headerType.changed';
export const HEADER_BASE_CONFIG = {
  actions: {
    type: '@sitebase/action-area',
    data: {
      id: 'hrs-action-area',
    },
    children: [],
  },
};

export const ANDROID_SPAIN_SPORTSBOOK_NATIVE_APP_USER_AGENT = 'd6596ce2-c402-4efa-950b-90c3646767ec';

export const IOS_UK_VEGAS_888_NATIVE_APP_USER_AGENT = 'c99a9785-8a16-4801-9474-02b5a8fbb58e';
export const ANDROID_UK_VEGAS_NATIVE_APP_USER_AGENT = '94492a82-8455-4746-89db-9437fb3546f9';

export const IOS_SPAIN_VEGAS_888_NATIVE_APP_USER_AGENT = '5eaaadc3-3145-4490-a4d8-db9bdf9d4182';
export const ANDROID_SPAIN_VEGAS_NATIVE_APP_USER_AGENT = 'e932bg67-7bz7-46d2-76c3-cK5J82bdd2a9';
